<script>
import { Link, useNavigate, useLocation } from "svelte-navigator";
import { resetPassword } from '../services';
import * as config from '../config.json';

const navigate = useNavigate();
const location = useLocation();

let loading = false;
let password = '';
let passwordConfirm = '';
let error;

let token;
let valid;

$: {
  const params = new URLSearchParams($location.search);
  token = params.get('token')
  valid = token?.length > 0;
}

async function handleSubmit(e) {
  if (password.length < 6) {
    error = "Password must be at least 6 characters";
    return;
  }

  if (password !== passwordConfirm) {
    error = "Passwords do not match";
    return;
  }

  error = undefined;
  loading = true;

  try {
    await resetPassword(config.eventId, token, password);
    navigate('/signin?changed=1', {replace: true});
  } catch (e) {
    error = e.message;
  } finally {
    loading = false;
  }
}
</script>


<div class="box">
  <div class="content">
    <div class="login-title">
      Set Password
    </div>

    {#if valid}

      <div class="login-subtitle">
        Please enter a new password.
      </div>

      <form on:submit|preventDefault={handleSubmit}>
        {#if error}
          <div class="error-box mb-4">{error}</div>
        {/if}

        <div class="col mb-4">
          <div class="form-label">Password</div>
          <input bind:value={password} type="password" name="password" placeholder="Password" />
        </div>

        <div class="col mb-4">
          <div class="form-label">Confirm Password</div>
          <input bind:value={passwordConfirm} type="password" name="password" placeholder="Password" />
        </div>

        <div class="row vcenter between" style="margin-top: 48px">
          <Link to="/signin">Back to login</Link>
          <button type="submit" class="button" disabled={loading}>SUBMIT</button>
        </div>
      </form>

    {:else}

      <div class="error-box mb-4">The link provided is invalid. Please try again.</div>

      <div class="button" on:click={() => navigate('/signin', {replace: true})}>BACK TO LOGIN</div>

    {/if}
  </div>
</div>

<style lang="scss">
@import '../login';
</style>